import './blocks/people-cards/script';
import './blocks/blog-intro/script';
import './blocks/faq-block/script';
import './blocks/dynamics-form/script';
import './blocks/two-column-with-speaker-and-text/script';
import './blocks/video/script';
import './blocks/two-column-quote-with-video/script';
import './blocks/talks-replay-grid/script';
import './blocks/article-content/script';
import './blocks/previous-editions-intro/script';
import './blocks/previous-editions-navy-box-with-background-image/script';

jQuery(document).ready(function($) {
    if (typeof acf !== 'undefined' && acf.fields && acf.fields.color_picker) {
        var palette = ['#2a3045','#ff3466', '#FFFFFF', '#e6e7e8', '#009CDE', '#FFB200', '#FF7300', '#707588', '#8C365D', '#3D4662', '#2C7879','#9095A7', '#6866C1', '#14D9B5', '#3B243F', '#A6DEED' ];

        acf.add_action('load', function() {
            $('input.wp-color-picker').each(function() {
                $(this).iris('option', 'palettes', palette);
            });
        });

        acf.add_action('append', function(el) {
            $(el).find('input.wp-color-picker').iris('option', 'palettes', palette);
        });
    }
});
